<template>
  <div>

    <vx-card>

      <vs-table-mod :data="courseOutlines"
                    :max-items="tableConfig.minItemsPerPage"
                    pagination
                    search
      >
        <template slot="header-left">

          <div class="vx-col md:w-1/4 sm:w-1/2 w-full mr-2">
            <!--              <label class="text-sm opacity-75">{{ $t('vdo-set.subject') }}</label>-->
            <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="subjects"
                      :placeholder="$t('vdo-set.search-subject')" @input="onSubjectChange"
                      @search="fetchOptions"
                      class="mb-4 md:mb-0"
                      label="label"
                      selectOnTab
                      v-model="local.selectedSubject">

              <!--label option-->
              <template #selected-option="{ code }">
                {{ code }}
              </template>

              <!--option list-->
              <template v-slot:option="option">
                {{ option.code }} {{ option.nameLocal }}
              </template>

              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{$t('general.no-result-for')}} <em>{{ search }}</em>.
                </template>
                <em style="opacity: 0.5;" v-else>{{$t('vdo-set.type-subject-code-to-search')}}</em>
              </template>

            </v-select>

          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <!--              <label class="text-sm opacity-75">{{ $t('vdo-set.teacher') }}</label>-->
            <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="teachers"
                      :placeholder="$t('vdo-set.search-teacher')" @input="onTeacherChange"
                      class="mb-4 sm:mb-0"
                      selectOnTab
                      v-model="local.selectedTeacher">

              <!--label option-->
              <template #selected-option="{ firstNameLocal, lastNameLocal }">
                {{ firstNameLocal }} {{ lastNameLocal}}
              </template>

              <!--option list-->
              <template v-slot:option="option">
                {{ option.code }} {{ option.firstNameLocal }} {{ option.lastNameLocal }}
              </template>
            </v-select>

          </div>

        </template>

        <template slot="thead"
                  v-for="(thead, indexth) in table.header"
        >
          <vs-th :key="indexth" :sort-key="thead.id">
            {{ $t(thead.title) }}
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr
            :data="{ data: tr, index: indextr }"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td width="40">
              {{ indextr + 1 }}
            </vs-td>
            <vs-td>
              {{ tr.subject.code }}
            </vs-td>
            <vs-td>
              {{ tr.subject.nameLocal }}
            </vs-td>
            <vs-td>
              {{ tr.subject.creditCalGrade }}
            </vs-td>

            <vs-td>
              <div class="flex items-center text-break">
                <vs-avatar :src="getAvatarUrl(tr.teacher.picturePath)" class="flex-shrink-0 mr-2"
                           size="30px"
                />
                {{ tr.teacher.code }}
                <br>
                {{ tr.teacher.firstNameLocal + ' '+ tr.teacher.lastNameLocal}}
              </div>
            </vs-td>

            <vs-td>
              {{ tr.courseOutlineUnits.length }}
            </vs-td>
            <vs-td>
              {{ tr.vdoSets.length }}
            </vs-td>

            <vs-td class="whitespace-no-wrap" width="100">

              <feather-icon @click="onEditClick(tr)" icon="EditIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
              <!--<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                            @click.prevent="onDeleteClick(tr)" />-->
            </vs-td>

          </vs-tr>
        </template>
      </vs-table-mod>

    </vx-card>

  </div>
</template>

<script>
  import {state, template, loadData} from '../data';
  import vSelect from 'vue-select'
  import {tableConfig} from '@/utils/table'
  import {getAvatarUrl} from "@/utils/upload";

  import Subject from '@/store/modules/common-data/subject/index';
  import Teacher from '@/store/modules/profile/teacher';
  import CourseOutline from '@/store/modules/courses/course-outline/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.Teacher) state.registerModule(`Teacher`, Teacher);
  if (!state.store.Subject) state.registerModule(`Subject`, Subject);
  if (!state.store.CourseOutline) state.registerModule(`CourseOutline`, CourseOutline);

  const {
    mapActions: mapSubjectActions,
  } = createNamespacedHelpers(`Subject`);
  const {
    mapActions: mapTeacherActions,
  } = createNamespacedHelpers(`Teacher`);
  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);


  const {
    mapFields: mapSubjectFields,
  } = createHelpers({
    getterType: `Subject/getField`,
    mutationType: `Subject/updateField`,
  });
  const {
    mapFields: mapTeacherFields,
  } = createHelpers({
    getterType: `Teacher/getField`,
    mutationType: `Teacher/updateField`,
  });
  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });

  export default {
    components: {
      vSelect,
      vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        table: template.table,
        tableConfig: tableConfig,
        getAvatarUrl: getAvatarUrl,

      }
    },
    computed: {
      ...mapSubjectFields({subjectProcessing: 'processing'}),
      ...mapTeacherFields({teacherProcessing: 'processing'}),
      ...mapCourseOutlineFields({courseOutlineProcessing: 'processing'}),
      subjects() {
        return this.local.subjects;
      },
      teachers() {
        return state.store.Teacher.teachersDdl;
      },
      courseOutlines() {
        return this.local.courseOutlines;
      },
    },
    watch: {
      subjectProcessing(data) {
        this.local.isProcessing = data;
      },
      teacherProcessing(data) {
        this.local.isProcessing = data;
      },
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapSubjectActions({
        getSubjectsByCodeOrName: 'getSubjectsByCodeOrName',
      }),
      ...mapTeacherActions({
        getTeachersDdl: 'getTeachersDdl',
      }),
      ...mapCourseOutlineActions({
        getCourseOutlinesByFilterForTable: 'getCourseOutlinesByFilterForTable',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onEditClick(tr) {
        this.$router.push({
          name: 'vdo-set-edit',
          params: {
            courseOutlineId: tr.id
          }
        });
      },
      /*async onDeleteClick() {

      },*/
      async onSubjectChange() {
        await this.loadData();
      },
      async onTeacherChange() {
        await this.loadData();
      },
      async fetchOptions(search, loading) {
        if (search && search.length >= 2) {
          loading(true);
          this.local.subjects = await this.getSubjectsByCodeOrName({codeOrName: search, limit: 20});
          loading(false);
        } else {
          this.local.subjects = [];
        }
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async initData() {
        // if ((!state.store.Teacher.teachers || state.store.Teacher.teachers.length === 0)) {
          await this.getTeachersDdl();
        // }
      },
      async loadData() {
        let func = {
          getCourseOutlinesByFilterForTable: this.getCourseOutlinesByFilterForTable
        }
        await loadData(func);
      },
    },
    async mounted() {
      await this.initData();
      // await this.loadData();
    }
  }
</script>

<style scoped>

</style>
